import { Sparkle } from "lucide-react";

interface LogoProps {
  className?: string;
  dark?: boolean;
}

export function Logo({ className = "", dark = false }: LogoProps) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div
        className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full bg-gradient-cosmic"
        aria-hidden="true"
      >
        <Sparkle size={17} fill="white" stroke="none" />
      </div>
      <span
        className={`text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-ink"}`}
      >
        Wara Cards
      </span>
    </div>
  );
}
